import React from 'react'
import { Technology, UsersTechnology } from '../../store/types'
import { Box } from '@mui/material'
import DefaultTechnologyLogo from './DefaultTechnologyLogo'

type TechnologyLogoProps = {
  size: number
  technology: UsersTechnology | Technology
}

const TechnologyLogo = ({ size, technology }: TechnologyLogoProps) => {
  if (technology.extension === null || technology.logo === null)
    return (
      <Box sx={{ width: size, height: size, borderRadius: 100 }}>
        <DefaultTechnologyLogo size={size} />
      </Box>
    )

  return (
    <Box
      component="img"
      alt={`${technology.name} logo`}
      src={`data:image/${technology.extension.toLowerCase()};base64,${technology.logo}`}
      sx={{ width: size, height: size, borderRadius: 100, bgcolor: 'background.dark' }}
    ></Box>
  )
}

export default TechnologyLogo
